var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.51367 6.04896C2.51367 3.03195 4.95943 0.586182 7.97643 0.586182C8.12931 0.586182 8.28086 0.592479 8.43078 0.604849C8.86039 0.640287 9.1798 1.01723 9.14437 1.44677C9.10894 1.87631 8.73201 2.1958 8.30248 2.16036C8.1951 2.1515 8.08639 2.14697 7.97643 2.14697C5.82144 2.14697 4.07446 3.89395 4.07446 6.04896V8.80212C4.07446 9.16555 3.98984 9.52398 3.8273 9.8491L2.99598 11.5117H12.9569L12.1256 9.8491C11.9631 9.52398 11.8784 9.16555 11.8784 8.80212V7.61045C11.8784 7.17944 12.2278 6.82935 12.6588 6.82935C13.0898 6.82935 13.4392 7.17874 13.4392 7.60975V8.80212C13.4392 8.92324 13.4675 9.04271 13.5216 9.15111L14.8612 11.8302C15.1466 12.401 14.7315 13.0725 14.0933 13.0725H10.9997C10.6532 14.4189 9.43101 15.4137 7.97643 15.4137C6.52193 15.4137 5.29973 14.4189 4.95321 13.0725H1.85954C1.2214 13.0725 0.80635 12.401 1.09173 11.8302L2.43128 9.15111C2.48546 9.04271 2.51367 8.92324 2.51367 8.80212V6.04896ZM6.62447 13.0725C6.89433 13.539 7.3987 13.8529 7.97643 13.8529C8.55416 13.8529 9.05853 13.539 9.32847 13.0725H6.62447ZM12.2686 2.14697C11.6221 2.14697 11.098 2.67107 11.098 3.31757C11.098 3.96407 11.6221 4.48816 12.2686 4.48816C12.9151 4.48816 13.4392 3.96407 13.4392 3.31757C13.4392 2.67107 12.9151 2.14697 12.2686 2.14697ZM9.53722 3.31757C9.53722 1.80906 10.7601 0.586182 12.2686 0.586182C13.7771 0.586182 15 1.80906 15 3.31757C15 4.82608 13.7771 6.04896 12.2686 6.04896C10.7601 6.04896 9.53722 4.82608 9.53722 3.31757Z",
    fill: "#172B4D",
    stroke: "#FAFAFA",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.920cb27a5e01c8a3d4ab2c0a6a0dbd58.svg";
export { ForwardRef as ReactComponent };